export default __webpack_public_path__ + "static/media/vehicle-moving.330c23f6.jpg";